/* eslint-disable @typescript-eslint/no-explicit-any */
import { Glue42 } from "../glue";
import { InternalConfig } from "./types";
import Utils from "./utils";

export class EventsDispatcher {
    private glue!: Glue42.Glue;
    private readonly glue42EventName = "Glue42";

    private readonly events: { [key in string]: { name: string; handle: (glue42Data: any) => void | Promise<void> } } = {
        notifyStarted: { name: "notifyStarted", handle: this.handleNotifyStarted.bind(this) },
        requestGlue: { name: "requestGlue", handle: this.handleRequestGlue.bind(this) }
    };

    constructor(private readonly config: InternalConfig) { }

    public start(glue: Glue42.Glue): void {

        if (Utils.isNode()) {
            // raising custom events is not supported in Node, because we can't raise global events and we do not at this
            // point expose an EventEmitter instance via the API
            return;
        }

        this.glue = glue;

        this.wireCustomEventListener();

        this.announceStarted();
    }

    private wireCustomEventListener(): void {
        window.addEventListener(this.glue42EventName, (event) => {
            const data = (event as CustomEvent).detail;

            if (!data || !data.glue42) {
                return;
            }

            const glue42Event: string = data.glue42.event;

            const foundHandler = this.events[glue42Event];

            if (!foundHandler) {
                return;
            }

            foundHandler.handle(data.glue42.message);

        });
    }

    private announceStarted(): void {
        this.send("start");
    }

    private handleRequestGlue(): void {
        if (!this.config.exposeGlue) {
            this.send("requestGlueResponse", { error: "Will not give access to the underlying Glue API, because it was explicitly denied upon initialization." });
            return;
        }

        this.send("requestGlueResponse", { glue: this.glue });
    }

    private handleNotifyStarted(): void {
        this.announceStarted();
    }

    private send(eventName: string, message?: any): void {
        const payload = { glue42: { event: eventName, message } };

        const event = new CustomEvent(this.glue42EventName, { detail: payload });

        window.dispatchEvent(event);
    }
}
